import type { CSSProperties } from 'react'

import type { NormalizedRect } from './imageContentBounds'

/** 将归一化内容区放大填满固定比例画框（overflow hidden 的父级内） */
export function portraitFocusImgStyle(rect: NormalizedRect): CSSProperties {
  const { x, y, w, h } = rect
  return {
    position: 'absolute',
    width: `${100 / w}%`,
    height: `${100 / h}%`,
    left: `${(-x / w) * 100}%`,
    top: `${(-y / h) * 100}%`,
    maxWidth: 'none',
    maxHeight: 'none',
  }
}

export const portraitFocusFallbackClass =
  'absolute inset-0 z-[1] h-full w-full object-cover object-[center_22%]'
